export enum FeaturesRoutingEnum {
  Home = '',
  Job = 'job',
  JobId = ':jobId',
  NotFound = '404',
}
